document.addEventListener("DOMContentLoaded", function () {
  const inspoAdviceCarousel = document.querySelector(
    ".inspiration-and-advice__swiper"
  );

  if (inspoAdviceCarousel) {
    let mobile = window.matchMedia(
      "(min-width: 0px) and (max-width: 767.98px)"
    );

    const swiperOptions = {
      // Optional parameters
      direction: "horizontal",
      freeMode: true,
      effect: "slide",
      autoplay: false,
      speed: 1000,
      // autoHeight: true,
      keyboard: true,
      slidesPerView: "auto",
      spaceBetween: 12,
      grabCursor: true,
      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };

    if (mobile.matches) {
      swiperOptions.centeredSlides = true;
      swiperOptions.loop = true;
      const swiper = new Swiper(
        ".inspiration-and-advice__swiper",
        swiperOptions
      );
    } else {
      const swiper = new Swiper(
        ".inspiration-and-advice__swiper",
        swiperOptions
      );
    }
  }
});
